import { components, useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import { forecastMetaDataQueryKeys } from "./queryKeys";

/**
 * Metadata from `GET /v2/forecast/metadata/table-metadata`. `gregMapping` maps
 * FISCAL period keys to CALENDAR labels — never index it by calendar
 * week. Bestseller's fiscal year starts in August (fiscal W01 =
 * calendar W32); other tenants may differ.
 */
export type ForecastMetaDataType = components["schemas"]["GridMetaData"];

/**
 * Fetches metadata for forecast grid
 */
export function useFetchForecastMetaData() {
  const apiClient = useApi();

  return useQuery({
    queryKey: forecastMetaDataQueryKeys.data(),
    meta: {
      errorMessage: "Failed to fetch meta data for forecast grid"
    },
    queryFn: async (): Promise<ForecastMetaDataType> => {
      const response = await apiClient.GET(
        "/v2/forecast/metadata/table-metadata"
      );
      const result = response.data?.result;
      if (!result) {
        throw new Error("Missing result in forecast metadata response");
      }
      return result;
    },
    staleTime: Infinity
  });
}
